import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* Failure is a real HTTP status with a { code, message } body; there is no
   status field inside the body any more. Some codes carry no message. */
const errorText = (err, fallback) => {
  const data = err.response?.data;
  return data?.message || data?.code || fallback;
};

/* ============================
   FETCH THE PORTAL NAVIGATION
============================ */
export const fetchAdminMenu = createAsyncThunk(
  "adminMenu/fetchAdminMenu",
  async (_, thunkAPI) => {
    try {
      const res = await api.get("/admin/menu");
      /* One of the handlers whose OWN top-level key is `data`: { data: rows }.
         res.data.data is correct here, not a leftover Node wrapper.

         A row is a MENU ENTRY, not a role:
           { id, title, path, icon, sortOrder, category,
             roles: [1|2|3], isActive }
         `roles` is a real array of role NUMBERS. Only is_active rows come
         back, and an entry with an empty roles array matches no role filter. */
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(errorText(err, "Failed to fetch admin menu"));
    }
  }
);

/* ============================
   SLICE
============================ */
const adminMenuSlice = createSlice({
  name: "adminMenu",
  initialState: {
    menu: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetStatus: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchAdminMenu.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.menu = action.payload;
      })
      .addCase(fetchAdminMenu.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStatus } = adminMenuSlice.actions;
export default adminMenuSlice.reducer;